export const spiralOptionsMap = [
    { value: "Silver", id: 0, price: 0, },
    { value: "Gold", id: 0, price: 0, },
]